import { Arbor } from "@/pages/catalogs/models/Arbor";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export const getArbors = async (
	params: { partId: number },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartId", value: params.partId }];

	const resp = await apiService.callV2("[M2].[GetArbors]", parameters, signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Arbor[];
	} else {
		throw new Error(resp.message || "Error fetching arbor");
	}
};
